/**
 * 页面加载异常处理
 *
 *    <PageLoading >
 *      ...
 *    </PageLoading>
 *
 *
 */
import { t } from 'i18next';
import React from 'react';

import { appName, isJoJoUp } from '@/config/base';
import LoadingFailSrcJo from '@/public/assets/images/error-net.png';
import LoadingErrorSrcJo from '@/public/assets/images/error-others.png';
import LoadingErrorSrcUp from '@/public/assets/images/jojoup/error-others.png';
import LoadingImageSrcUp from '@/public/assets/images/jojoup/loading.gif';
import LoadingImageSrcJo from '@/public/assets/images/loading.gif';
import { NETWORK_ERROR_TIPS } from '@/utils/data';

import styles from './index.less';

const LoadingFailSrc = isJoJoUp ? LoadingErrorSrcUp : LoadingFailSrcJo;
const LoadingErrorSrc = isJoJoUp ? LoadingErrorSrcUp : LoadingErrorSrcJo;
const LoadingImageSrc = isJoJoUp ? LoadingImageSrcUp : LoadingImageSrcJo;
// 加载状态
export const LoadStatus = {
  Loading: 'loading',
  Success: 'success',
  Fail: 'fail',
  Error: 'error'
};

interface ResponseProps {
  data?: any;
  status?: number;
  resultCode?: number;
  code?: string;
  errorMsg?: string;
}

export function LoadHandle(res: ResponseProps, options?: any) {
  const _trans = t;

  // 进入授权
  if (res.status && [1001, 1002, 1005].includes(res.status)) {
    //
    return {
      status: LoadStatus.Loading,
      loadingText: _trans(
        'PageLoading.WeChatCanEnterTheAccessAfterAuthorizationRequestAuthorization',
        '微信授权后可进入访问，请求授权中···'
      ),
      ...options
    };
  }
  if (res.resultCode === 200) {
    //
    return {
      status: LoadStatus.Success,
      ...options
    };
  }
  if (res.code === 'SUCCESS') {
    //
    return {
      status: LoadStatus.Success,
      ...options
    };
  }
  if (res.resultCode) {
    //
    return {
      status: LoadStatus.Error,
      loadErrorText:
        res.errorMsg || _trans('PageLoading.OhWellSomethingWentWrong', '哦哦，出错了！'),
      ...options
    };
  }
  //
  return {
    status: LoadStatus.Fail,
    ...options
  };
}

export function LoadSuccess(data: any) {
  return {
    data,
    res: {
      resultCode: 200
    }
  };
}

interface ContentComponentProps {
  loadText: string | null;
  loadImage: string;
  textCls: string;
  imageCls: string;
}

export interface LoadOptions {
  status?: number | string;
  loadingImage?: string;
  loadingText?: string;
  loadFailImage?: string;
  loadFailText?: string;
  loadErrorImage?: string;
  loadErrorText?: string;
  loadContent?: React.FunctionComponent<ContentComponentProps> | string;
}

interface PageProps {
  children?: React.ReactChildren | React.ReactNode;
  loadOptions: LoadOptions;
  doRequest?: (ops: any, type: any) => void;
  query?: any;
}

console.log(t);

function Index(props: PageProps) {
  const _trans = t;

  const { children, loadOptions, doRequest, query } = props;
  const {
    status,
    loadingImage,
    loadingText,
    loadFailImage,
    loadFailText = '',
    loadErrorImage,
    loadErrorText = '',
    loadContent: Content = ''
  } = loadOptions;
  let imageSrc = loadingImage || LoadingImageSrc;
  let loadText = loadingText || _trans('PageLoading.ShoutingIsComing', `${appName}正在赶来...`);

  const onRequest = () => {
    //
    if (status !== LoadStatus.Fail) {
      //
      return;
    }
    //
    if (doRequest) {
      //
      doRequest(query, 'reload');
    }
  };
  //
  if (status === LoadStatus.Fail) {
    //
    imageSrc = loadFailImage || LoadingFailSrc;
    loadText = loadFailText || NETWORK_ERROR_TIPS;
  }
  if (status === LoadStatus.Error) {
    imageSrc = loadErrorImage || LoadingErrorSrc;
    loadText = loadErrorText || '';
  }
  //
  if (status !== LoadStatus.Success) {
    return (
      <div className={styles.loading} onClick={onRequest}>
        <div className={styles.loadingWp}>
          {Content ? (
            <Content
              loadText={loadText || ''}
              loadImage={imageSrc}
              textCls={styles.loadingText}
              imageCls={styles.loadingImage}
            />
          ) : (
            <>
              <img className={styles.loadingImage} src={imageSrc} alt='' />
              <p className={styles.loadingText}>{loadText}</p>
            </>
          )}
        </div>
      </div>
    );
  }
  return <>{children}</>;
}

export default Index;
